import styled from 'styled-components';
export const Container = styled.div `
  .react-tabs {
    display: flex;
    flex-direction: ${({ $direction }) => ($direction === 'vertical' ? 'row' : 'column')};
    justify-content: space-between;
  }
`;
